import { Container, Text } from '@melio/penny';

import { config } from '../../config';
import { CDN_BRANCH_COOKIE_NAME, ORIG_BRANCH_COOKIE_NAME } from '../../../handlers/web-index/constants';

const getCookieValueByName = (name: string) => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

export const EnvironmentRibbon = () => {
  if (config.production) {
    return null;
  }

  const branchName = getCookieValueByName(ORIG_BRANCH_COOKIE_NAME);
  const sha = getCookieValueByName(CDN_BRANCH_COOKIE_NAME);
  const envName = branchName || sha || config.environment;

  return (
    <Container
      data-testid="environment-ribbon"
      style={{
        width: '150px',
        height: '150px',
        position: 'absolute',
        overflow: 'hidden',
        top: 0,
        zIndex: 9999,
        right: 0,
        pointerEvents: 'none',
      }}
    >
      <Container
        style={{
          position: 'absolute',
          zIndex: 9999,
          transform: 'rotate(45deg)',
          top: '32px',
          right: '-56px',
          backgroundColor: '#00D28F',
          paddingTop: '5px',
          paddingBottom: '5px',
          paddingLeft: '20px',
          paddingRight: '20px',
          minWidth: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'auto',
        }}
        title={envName}
      >
        <Text
          as="div"
          style={{
            color: 'white',
            fontSize: '12px',
            lineHeight: '16px',
            textTransform: 'uppercase',
            textAlign: 'center',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            width: '100%',
            maxWidth: '200px',
            minWidth: 0,
            boxSizing: 'border-box',
          }}
        >
          {envName}
        </Text>
      </Container>
    </Container>
  );
};
